import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { getCanDrag } from '../../util';
var Context = /*#__PURE__*/React.createContext({
  isDraggingFiles: false,
  cancelDragAndDrop: function cancelDragAndDrop() {},
  onFilesDropped: function onFilesDropped() {}
});
function isDataTransferFiles(dataTransfer) {
  if (dataTransfer.items && dataTransfer.items.length > 0) {
    return Array.from(dataTransfer.items).some(function (item) {
      return item.kind.toLowerCase() === 'file' || item.type === 'text/uri-list';
    });
  }
  return dataTransfer.types.some(function (type) {
    return type.toLowerCase() === 'files';
  });
}
export var DragAndDropContextProvider = function DragAndDropContextProvider(_ref) {
  var children = _ref.children,
    fullscreen = _ref.fullscreen;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDraggingFiles = _React$useState2[0],
    setIsDraggingFiles = _React$useState2[1];
  var canDrag = useMemo(function () {
    return getCanDrag();
  }, []);
  var cancelDragAndDrop = React.useCallback(function (e) {
    setIsDraggingFiles(false);
    e.stopPropagation();
    e.preventDefault();
  }, []);
  var fullscreenStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    display: 'contents'
  };
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      isDraggingFiles: isDraggingFiles,
      cancelDragAndDrop: cancelDragAndDrop,
      onFilesDropped: onFilesDropped
    }
  }, /*#__PURE__*/React.createElement("div", {
    onDragOver: function onDragOver(e) {
      if (!canDrag || !isDataTransferFiles(e.dataTransfer)) {
        return;
      }
      setIsDraggingFiles(true);
      e.stopPropagation();
      e.preventDefault();
    },
    style: fullscreen ? fullscreenStyle : {
      display: 'contents'
    },
    "data-testid": "drag-drop-context"
  }, children));
  function onFilesDropped() {
    setIsDraggingFiles(false);
  }
};
export var useDragAndDropContext = function useDragAndDropContext() {
  return React.useContext(Context);
};